<script setup>

import TagComponent from "@/components/TagComponent.vue";
import { useMiscStore } from "@/stores/misc";
import LikeButtonComponent from "../LikeButtonComponent.vue";
import CommentCountComponent from "@/components/shared/CommentCountComponent.vue";

const misc = useMiscStore(),
  props = defineProps({
    businesses: {
      type: Array,
      default: () => [],
   },
   type: {
     type: String,
     default: "contributor",
   }
  }),
 setCurrentSectorAndCategory = (sector, category) => {
  misc.setCurrentSector(sector);
  misc.setCurrentCategory(category);
};
</script>

<template>
  <ul class="">
    <li
      v-for="business in props.businesses"
      :key="business.id"
      class="flex flex-wrap px-0 justify-between items-center py-1.5 border-t"
    >
      <router-link
        :to="`/users/${business.creator.id}/${business.sector.name.toLowerCase()}/${business.category.name.toLowerCase()}/${
          business.id
        }`"
        target="_self"
        class="mb-1 font-medium text-gray-600 text-left w-full px-4 h5 text-xs overflow-hidden whitespace-nowrap overflow-ellipsis"
        @click="
          setCurrentSectorAndCategory(business.sector, business.category)
        "
      >
        {{ business.name }}
      </router-link>
      <div class="text-xs mt-2 px-4 flex justify-between items-center w-full">
        <div class="items-center flex flex-grow no-more">
          <LikeButtonComponent
            :id="business.id"
            :count="business.likeCount"
            :user-has-liked="business.liked"
            size="h-4 w-4"
            :from="props.type"
          />
          <CommentCountComponent
            :id="business.id"
            :count="business.reviewCount"
            :from="props.type"
          />
        </div>
        <span class="text-gray-500 flex justify-between items-center">
          <!--            <span class="ml-2 text-xs">-->
          <!--              12 year ago-->
          <!--            </span>-->
          <router-link
            :to="{
              name: 'UserBusinessCategory',
              params: {
                username: business.creator.id,
                sector: business.sector.slug,
                category: business.category.slug
              }
            }"
            class="tag self-center text-xs"
            @click="setCurrentSectorAndCategory(business.sector, business.category)"
          >
            <TagComponent
              :title="business.category.name"
              :bg-color="business.category.background"
              :color="business.category.color"
              :class="`text-[10px] rounded-md px-1 py-[1.5px]`"
            />
          </router-link>
        </span>
      </div>
    </li>
  </ul>
</template>

<style scoped>

</style>
